import { render, staticRenderFns } from "./editLetterPage.vue?vue&type=template&id=4648ad4a&"
import script from "./editLetterPage.vue?vue&type=script&lang=js&"
export * from "./editLetterPage.vue?vue&type=script&lang=js&"
import style0 from "./editLetterPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports